import './pages.css';
import { useLocation } from 'react-router-dom';
import DailyOverview from '../components/Cards/DailyOverviewChart';
import DatePickerComponent from '../components/Filters/DatePicker';
import EnvironmentFilter from '../components/Filters/EnvironmentFilter';
import FrameworkFilter from '../components/Filters/FrameworkFilter';
import HighFailureRate from '../components/Cards/HighFailureRate';
import LastSyncDisplay from '../components/LastSyncDisplay';
import NewFailuresCard from '../components/Cards/NewFailures';
import PackageFilter from '../components/Filters/PackageFilter';
import React, { useState } from 'react';
import SuccessRateCard from '../components/Cards/DailySuccessRate';
import TestResultsTable from '../components/BrokenTestsTable/BrokenTestsTable';
import useFiltersData from '../hooks/useFiltersData';
import useLastSync from '../hooks/useLastSync';
import usePackages from '../hooks/usePackages';

function Filters({ selectedDate, setSelectedDate, selectedEnvironment, setSelectedEnvironment, selectedPackage, setSelectedPackage, selectedFramework, setSelectedFramework, lastSync, lastSyncLoading, availablePackages, packagesLoading }) {  
    return (
    <div className="filters-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
      <DatePickerComponent 
        selectedDate={selectedDate} 
        setSelectedDate={setSelectedDate} 
        maxDate={new Date()}
      />
      <EnvironmentFilter selectedEnvironment={selectedEnvironment} setSelectedEnvironment={setSelectedEnvironment} />
      <PackageFilter 
        selectedPackage={selectedPackage} 
        setSelectedPackage={setSelectedPackage} 
        availablePackages={availablePackages}
        loading={packagesLoading}
      />
      <FrameworkFilter selectedFramework={selectedFramework} setSelectedFramework={setSelectedFramework} />
      <LastSyncDisplay lastSync={lastSync} loading={lastSyncLoading} />
    </div>
  );
}

function Application() {
  const [filters, setFilters] = useState({
    selectedDate: new Date(),
    selectedEnvironment: 'All Environments',
    selectedPackage: 'app',
    selectedFramework: 'All Frameworks'
  });
  
  const location = useLocation();
  const setSelectedDate = (date) => setFilters(prev => ({ ...prev, selectedDate: date }));
  const setSelectedEnvironment = (env) => setFilters(prev => ({ ...prev, selectedEnvironment: env }));
  const setSelectedPackage = (pkg) => setFilters(prev => ({ ...prev, selectedPackage: pkg }));
  const setSelectedFramework = (framework) => setFilters(prev => ({ ...prev, selectedFramework: framework }));

  const oneWeek = 7 * 24 * 60 * 60 * 1000;
  const startDate = new Date(filters.selectedDate - oneWeek).toISOString().split('T')[0];
  const endDate = filters.selectedDate.toISOString().split('T')[0];

  const { data, loading, error } = useFiltersData(
    startDate,
    endDate,
    filters.selectedEnvironment, 
    filters.selectedPackage,
    filters.selectedFramework,
    'All Units'
  );

  const { data: lastSync, loading: lastSyncLoading }  = useLastSync(
    filters.selectedEnvironment, 
    filters.selectedPackage
  );

  const { data: availablePackages, loading: packagesLoading } = usePackages("app");

  return (
    <div className="application-container table-owns-scroll">
      {location.pathname === '/application' && (
        <>
          <Filters 
            selectedDate={filters.selectedDate} 
            setSelectedDate={setSelectedDate} 
            selectedEnvironment={filters.selectedEnvironment} 
            setSelectedEnvironment={setSelectedEnvironment} 
            selectedPackage={filters.selectedPackage} 
            setSelectedPackage={setSelectedPackage} 
            selectedFramework={filters.selectedFramework} 
            setSelectedFramework={setSelectedFramework} 
            lastSync={lastSync}
            lastSyncLoading={lastSyncLoading}
            availablePackages={availablePackages}
            packagesLoading={packagesLoading}
          />
          <div className="flex-container">
            <div className="cards-container">
              <DailyOverview
                selectedDate={filters.selectedDate}
                selectedEnvironment={filters.selectedEnvironment}
                selectedPackage={filters.selectedPackage}
                selectedFramework={filters.selectedFramework}
                selectedUnit='All units'
                data={data} // Pass data to DailyOverview
                loading={loading} // Pass loading state
                error={error} // Pass error state
              />
              <SuccessRateCard 
                selectedDate={filters.selectedDate}
                selectedEnvironment={filters.selectedEnvironment}
                selectedPackage={filters.selectedPackage}
                selectedFramework={filters.selectedFramework}
                data={data} // Pass data to SuccessRateCard
                loading={loading} // Pass loading state
                error={error} // Pass error state
              />
              <NewFailuresCard
                selectedDate={filters.selectedDate}
                selectedEnvironment={filters.selectedEnvironment}
                selectedPackage={filters.selectedPackage}
                selectedFramework={filters.selectedFramework}
              />
              <HighFailureRate />
            </div>
          </div>
          <TestResultsTable
            selectedDate={filters.selectedDate}
            selectedEnvironment={filters.selectedEnvironment}
            selectedPackage={filters.selectedPackage}
            selectedFramework={filters.selectedFramework}
            selectedUnit='All units'
          />
        </>
      )}
    </div>
  );
}

export default Application; 